module.exports = __webpack_public_path__ + "img/2-2.3bf49a60.png";